import { useEffect } from 'react';
interface SeoProps {
  title: string;
  description: string;
  schema?: Record<string, unknown>;
}
function setMeta(name: string, content: string) {
  let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}
export function Seo({
  title,
  description,
  schema
}: SeoProps) {
  useEffect(() => {
    document.title = title;
    setMeta('description', description);
  }, [title, description]);
  useEffect(() => {
    if (!schema) return;
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [schema]);
  return null;
}